import { render } from "./DashboardPoint.vue?vue&type=template&id=b8c9f65c"
import script from "./DashboardPoint.vue?vue&type=script&lang=js"
export * from "./DashboardPoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__